import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "xmlexportpreference"
    }}>{`XMLExportPreference`}</h1>
    <p>{`XML export preferences.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the XMLExportPreference (a Application or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`viewAfterExport`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, displays exported XML content in a specified viewer.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`preferredBrowser`}</strong>{` `}</p>
      <p parentName="blockquote">{`The preferred browser for viewing XML. Can return: File or NothingEnum enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`exportFromSelected`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, exports XML content from the selected XML element. If false, exports the entire document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLFileEncoding `}<strong parentName="p">{`fileEncoding`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file encoding type for exporting XML content.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`ruby`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, includes Ruby text in the exported XML content.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`excludeDtd`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, excludes the DTD from the exported XML content.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`copyOriginalImages`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, copies original images to the images subfolder.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`copyOptimizedImages`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, copies optimized images to the images subfolder.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`copyFormattedImages`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, copies formatted images to the images subfolder.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageConversion `}<strong parentName="p">{`imageConversion`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file format to use for converted images. Note: Valid only when copy optimized images and/or copy formatted images is true.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`GIFOptionsPalette `}<strong parentName="p">{`gifOptionsPalette`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color palette for GIF conversion. Note: Not valid when image conversion is JPEG.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`gifOptionsInterlaced`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, generates interlaced GIFs. Note: Not valid  when image conversion is JPEG.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`JPEGOptionsQuality `}<strong parentName="p">{`jpegOptionsQuality`}</strong>{` `}</p>
      <p parentName="blockquote">{`The quality of converted JPEG images. Note: Not valid when image conversion is GIF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`JPEGOptionsFormat `}<strong parentName="p">{`jpegOptionsFormat`}</strong>{` `}</p>
      <p parentName="blockquote">{`The formatting method for converted JPEG images. Note: Not valid  when image conversion is GIF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`allowTransform`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, transforms the XML using an XSLT file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`transformFilename`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the XSLT file. Note: Valid when allow transform is true. Can return: File or XMLTransformFile enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`characterReferences`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, replaces special characters with character references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportUntaggedTablesFormat `}<strong parentName="p">{`exportUntaggedTablesFormat`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export format for untagged tables in tagged stories.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the XMLExportPreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`XMLExportPreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      